<section role="region" class="homeB-employer">
  <header role="banner" class="homeB-employer__header">
    <h2 role="heading" class="homeB-employer__header__title">
      <span class="line-break">Je suis employeur,</span>
      <span class="highlight--white">je découvre les solutions pour m&apos;aider à recruter</span>
    </h2>
  </header>

  <ul class="homeB-employer__list">
    <li *ngFor="let item of contentEmployer; trackBy: trackByItemTilte">
      <app-card [cardContent]="item" [isSmall]="(isMobile$ | async) === false"></app-card>
    </li>
  </ul>
</section>
